<template>
    <div>
        <table
            role="table"
            aria-busy="false"
            aria-colcount="5"
            class="table b-table mb-3 mt-3 table-striped table-hover table-sm border b-table-stacked-md"
        >
            <thead>
                <tr role="row">
                    <th scope="col" aria-colindex="1" class="">
                        <div>Responsável Familiar</div>
                    </th>
                    <th scope="col" aria-colindex="2" class="">
                        <div>Endereço</div>
                    </th>
                    <th scope="col" aria-colindex="3" class="">
                        <div>Membros</div>
                    </th>
                    <!-- <th scope="col" aria-colindex="4" class="">
						<div>Status</div>
					</th> -->
                </tr>
            </thead>
            <tbody>
                <tr role="row" v-for="(item, index) in dados" :key="index">
                    <td
                        aria-colindex="1"
                        data-label="Responsável Familiar"
                        role="cell"
                    >
                        <div v-if="item.dados">
                            <!-- <strong> Marcos Ferreira Lima </strong> -->
                            <ul
                                class="small"
                                v-for="(membro, index) in item.dados.membros"
                                :key="index"
                            >
                                <li>{{ membro.nome_completo }}</li>
                            </ul>
                            <!---->
                            <span v-if="item.dados.id" class="small"
                                ><b>ID no Sistema</b> {{ item.dados.id }}</span
                            >
                            <span
                                v-if="item.dados.codigo_familiar"
                                class="small"
                                ><b>Código no Cad Único</b>
                                {{ item.dados.codigo_familiar }}</span
                            >
                        </div>
                    </td>
                    <td
                        aria-colindex="2"
                        data-label="Endereço"
                        role="cell"
                        class=""
                    >
                        <div>
                            <div class="small" v-if="item.dados">
                                <strong
                                    >{{ item.dados.tipo_logradouro }}
                                    {{ item.dados.nome_logradouro }}
                                </strong>
                                {{ item.dados.numero_endereco }}
                                <br />
                                {{ item.dados.cidade }}, CEP:
                                {{ item.dados.cep_logradouro }}<br />
                            </div>
                        </div>
                    </td>
                    <td
                        aria-colindex="3"
                        data-label="Membros"
                        role="cell"
                        class=""
                    >
                        <div v-if="item.dados">
                            {{
                                item.dados.membros
                                    ? item.dados.membros.length
                                    : 0
                            }}
                        </div>
                    </td>
                    <!-- <td aria-colindex="4" data-label="Status" role="cell" class="">
						<div>
							<span class="small"
								><b class="text-info"
									><i class="mdi mdi-information-outline"></i> EM CADASTRAMENTO</b
								></span
							>
						</div>
					</td> -->
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: ["dados"],
};
</script>
<style>
.router-link-exact-active {
    cursor: pointer;
}
</style>
